import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import Box from 'components/atoms/Layout/Box/Box';

const StyledWrapper = styled(Box)`
  ${ComponentStyles}
`;

StyledWrapper.propTypes = {
  theme: PropTypes.object
};

export default StyledWrapper;
